export class CommentConstants {
  public static readonly UISetting = {
    width: 740,
    headerBarHeight: 110,
    /** コメント作成フォーム（CreatingModelCommentView）の textarea 最小行数 */
    formMinRows: 4,
  };
}
